import { attr, belongsTo, hasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Code = ApplicationRecord.extend({
  attrs: {
    code: attr({ persist: false }),
    promotion: belongsTo({ type: 'vouchers-promotions', persist: false }),
    redemptions: hasMany({ type: 'vouchers-redemptions', persist: false }),
    redemptions_count: attr({ persist: false }),
  },
  static: {
    endpoint: '/codes',
    jsonapiType: 'vouchers-codes',
  },
});

export default Code;
